import {
  Box,
  CardActionArea,
  Typography
} from '@mui/material';

import Image from 'next/image';

import LocationOnIcon from '@mui/icons-material/LocationOn';
import Rating from '@mui/material/Rating';

import { NextLinkComposed } from '../components/Link';


const BusinessCard = ({business}) => {

  return (
    <CardActionArea
      component={NextLinkComposed}
      to={{ pathname: `/mechanic/${business.url_name}` }}
      sx={{
        width: "100%",
        bgcolor: "white",
        py: {
          xs: 1,
          lg: 4,
        },
        px: {
          xs: 1,
          lg: 2,
        },
        mb: {
          xs: 2,
          lg: 0
        }
      }}>
      <Box
        display="flex"
        alignItems="center"
        fontFamily="fontFamily"
      >
        <Box
          sx={{
            display: "flex",
            flexShrink: 0,
            alignItems: "center",
            width: {
              xs: "120px",
              md: "165px",
            },
            height: {
              xs: "120px",
              md: "165px",
            },
            mr: {
              xs: 1,
              md: 4
            },
            position: "relative",
          }}
        >
          <Image
            src={business.logo ? business.logo + '?w=165' : '/img/profile-placeholderx2.jpg'}
            title={business.name}
            alt={business.name}
            quality={100}
            layout="fill"
            objectFit="cover"
          />
        </Box>
        <Box flexGrow={1}>
          <Typography variant="h5">
            {business.name}
          </Typography>
          <Box py={1} display="flex" alignItems="center" flexWrap="wrap">
            <Rating name="read-only" value={business.rating} readOnly precision={0.5} />
            <Box
              sx={{
                color: 'primary.light',
                ml: 1,
                fontSize: {
                  xs: 12,
                  sm: 'body2.fontSize'
                }
              }}
            >{business.total_ratings} ratings</Box>
          </Box>
          <Box display="flex" alignItems="center" color="text.secondary">
            <LocationOnIcon fontSize="small" />
            <Box
              ml={1}
              component="div"
              overflow="hidden"
              textOverflow="ellipsis"
              sx={{
                fontSize: {
                  xs: 12,
                  sm: 'body2.fontSize'
                },
                lineHeight: {
                  xs: 1.2,
                  sm: 1.5,
                }
              }}
            >{business.address}</Box>
          </Box>
        </Box>
      </Box>
    </CardActionArea>
  )
}

export default BusinessCard;
